/*
  gjh-hover-video.js — owner 2026-10-23: "when the mouse hovers over on desktop, the
  video pops up. Can that video auto-play when I hover over with my mouse?"

  Dawn's product cards swap to the product's SECOND media on hover. When that media
  is a video, Dawn can only show its still frame (preview_images/…thumbnail.jpg).
  This plays the real video over that still, muted and looping, while the mouse is
  on the card, and stops + rewinds it when the mouse leaves.

  - Desktop mouse only (hover + fine pointer, 990px+, Dawn's hover-swap breakpoint);
    phones keep the gjh-shopux2 swipe carousel untouched. Off with reduced motion.
  - Nothing is downloaded until the mouse RESTS on a card (150 ms): the video URL
    comes from /products/<handle>.js (once per product), 480p or 720p mp4 by screen
    density. A video that never started (the mouse left first) is removed so its
    download stops; one that played is kept, paused, for the next hover.
  - The video is appended inside .media--hover-effect AFTER the two <img>s, so
    Dawn's img:first-child / img + img hover rules are unchanged; visibility is
    pure CSS (:hover), so the gjh-shopux2 rule that shows the first photo while the
    swatches/price are hovered hides the video too.
*/
(function () {
  'use strict';
  if (!window.matchMedia || !window.fetch) return;
  var desk = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var css = document.createElement('style');
  css.textContent =
    '.media--hover-effect>video.gjh-hovervid{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;' +
    'opacity:0;pointer-events:none;transition:opacity .25s ease,transform var(--duration-long,.5s) ease}' +
    '@media (hover:hover) and (pointer:fine) and (min-width:990px){' +
    '.card-wrapper:hover .media--hover-effect>video.gjh-hovervid.is-ready{opacity:1;transform:scale(1.03)}' +
    '.gjhq-card.card-wrapper:has(.gjhq-ctl:hover,.gjhq-atc:hover,.gjhq-bar:hover) .media--hover-effect>video.gjh-hovervid{opacity:0!important}}' +
    '@media (hover:none),(max-width:989px){.media--hover-effect>video.gjh-hovervid{display:none}}';
  document.head.appendChild(css);

  var urls = Object.create(null);

  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    var m = a && (a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
    return m ? m[1] : null;
  }

  // Dawn's second card image, but only when it is a video's still frame.
  function stillOf(card) {
    var imgs = card.querySelectorAll('.media--hover-effect > img');
    var img = imgs[1];
    if (!img) return null;
    return /\/preview_images\//.test(img.currentSrc || img.src || '') ? img : null;
  }

  function videoUrl(handle) {
    if (!urls[handle]) {
      urls[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var media = (p && p.media) || [];
          var vid = null;
          for (var i = 0; i < media.length; i++) { if (media[i].media_type === 'video') { vid = media[i]; break; } }
          if (!vid) return null;
          var mp4 = (vid.sources || []).filter(function (s) { return s.format === 'mp4' && s.url; })
            .sort(function (a, b) { return (a.height || 0) - (b.height || 0); });
          if (!mp4.length) return null;
          var want = (window.devicePixelRatio || 1) > 1.5 ? 700 : 450;
          var pick = mp4.filter(function (s) { return (s.height || 0) >= want; })[0] || mp4[mp4.length - 1];
          return pick.url;
        })
        .catch(function () { return null; });
    }
    return urls[handle];
  }

  function play(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function enter(card) {
    var still = stillOf(card);
    if (!still) return;
    var box = still.parentElement;
    var v = box.querySelector('video.gjh-hovervid');
    if (v) { play(v); return; }
    var handle = handleOf(card);
    if (!handle) return;
    videoUrl(handle).then(function (url) {
      // The mouse already left: do not start a download nobody will watch.
      if (!url || !card.__gjhHover || box.querySelector('video.gjh-hovervid')) return;
      v = document.createElement('video');
      v.className = 'gjh-hovervid';
      v.muted = true;
      v.defaultMuted = true;
      v.loop = true;
      v.playsInline = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('aria-hidden', 'true');
      v.setAttribute('tabindex', '-1');
      v.preload = 'auto';
      v.poster = still.currentSrc || still.src;
      v.src = url;
      v.addEventListener('playing', function () { v.classList.add('is-ready'); });
      box.appendChild(v);
      play(v);
    });
  }

  function leave(card) {
    var v = card.querySelector('video.gjh-hovervid');
    if (!v) return;
    v.pause();
    if (!v.classList.contains('is-ready')) {
      // Never got to play: drop it so the browser stops fetching the mp4.
      v.removeAttribute('src');
      try { v.load(); } catch (e) {}
      v.remove();
      return;
    }
    try { v.currentTime = 0; } catch (e) {}
  }

  document.addEventListener('mouseover', function (e) {
    if (!desk.matches || !e.target.closest) return;
    var card = e.target.closest('.card-wrapper');
    if (!card || card.__gjhHover) return;
    card.__gjhHover = true;
    clearTimeout(card.__gjhHoverT);
    card.__gjhHoverT = setTimeout(function () {
      if (card.__gjhHover) enter(card);
    }, 150);
  });

  document.addEventListener('mouseout', function (e) {
    if (!e.target.closest) return;
    var card = e.target.closest('.card-wrapper');
    if (!card || !card.__gjhHover) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    card.__gjhHover = false;
    clearTimeout(card.__gjhHoverT);
    leave(card);
  });
})();
